import { Controller } from "@hotwired/stimulus"
import { KCAL_TO_KJ } from "~/lib/energy"

export default class extends Controller {
  static targets = ["kcal", "kj"]
  fromKcal() { this.kjTarget.value = this.convert(this.kcalTarget.value, KCAL_TO_KJ) }
  fromKj() { this.kcalTarget.value = this.convert(this.kjTarget.value, 1 / KCAL_TO_KJ) }
  convert(value, factor) { return value === "" ? "" : (Math.max(0, Number(value)) * factor).toFixed(1) }
}
